const isNullOrUndefined = value =>
  value === null || typeof value === 'undefined';

export default isNullOrUndefined;
